import(/* webpackMode: "eager" */ "/app/apps/explore/app/global-error.tsx");
